const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssistanceSlideLine3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 537 281",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.84,377.15C788.606,377.03 788.337,376.961 788.051,376.961C787.765,376.961 787.496,377.03 787.263,377.15L778.872,369.393C778.239,368.808 777.211,368.808 776.577,369.393C775.943,369.979 775.943,370.929 776.577,371.515L786.904,381.061C787.537,381.646 788.565,381.646 789.198,381.061L799.525,371.515C800.158,370.929 800.158,369.979 799.525,369.393C798.892,368.808 797.864,368.808 797.23,369.393L788.84,377.15Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.431,366.069L786.429,366.146L786.429,369.224C786.429,370.053 787.154,370.724 788.051,370.724C788.919,370.724 789.628,370.095 789.672,369.301L789.674,369.224L789.674,366.146C789.674,365.317 788.947,364.646 788.051,364.646C787.183,364.646 786.474,365.276 786.431,366.069Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.431,353.754L786.429,353.831L786.429,356.909C786.429,357.738 787.154,358.409 788.051,358.409C788.919,358.409 789.628,357.78 789.672,356.986L789.674,356.909L789.674,353.831C789.674,353.002 788.947,352.331 788.051,352.331C787.183,352.331 786.474,352.961 786.431,353.754Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.431,341.438L786.429,341.515L786.429,344.594C786.429,345.423 787.154,346.094 788.051,346.094C788.919,346.094 789.628,345.465 789.672,344.671L789.674,344.594L789.674,341.515C789.674,340.687 788.947,340.015 788.051,340.015C787.183,340.015 786.474,340.646 786.431,341.438Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.431,329.123L786.429,329.2L786.429,332.279C786.429,333.108 787.154,333.779 788.051,333.779C788.919,333.779 789.628,333.15 789.672,332.356L789.674,332.279L789.674,329.2C789.674,328.372 788.947,327.7 788.051,327.7C787.183,327.7 786.474,328.331 786.431,329.123Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.431,316.808L786.429,316.885L786.429,319.964C786.429,320.793 787.154,321.464 788.051,321.464C788.919,321.464 789.628,320.835 789.672,320.041L789.674,319.964L789.674,316.885C789.674,316.057 788.947,315.385 788.051,315.385C787.183,315.385 786.474,316.016 786.431,316.808Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.431,304.493L786.429,304.57L786.429,307.649C786.429,308.478 787.154,309.149 788.051,309.149C788.919,309.149 789.628,308.52 789.672,307.726L789.674,307.649L789.674,304.57C789.674,303.742 788.947,303.07 788.051,303.07C787.183,303.07 786.474,303.701 786.431,304.493Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.428,293.415L786.429,295.334C786.429,296.162 787.154,296.834 788.051,296.834C788.919,296.834 789.628,296.204 789.672,295.411L789.674,295.334L789.674,293.795C789.674,293.4 789.671,293.006 789.665,292.614L789.658,292.222C789.64,291.393 788.899,290.735 788.004,290.751C787.136,290.767 786.44,291.409 786.413,292.202L786.428,293.415Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M785.599,282.955L785.656,283.328C785.78,284.149 786.598,284.722 787.487,284.608C788.347,284.498 788.956,283.784 788.881,282.993L788.871,282.916C788.735,282.009 788.582,281.109 788.413,280.217L788.339,279.835C788.179,279.019 787.335,278.478 786.454,278.625C785.599,278.769 785.023,279.505 785.133,280.292L785.146,280.368C785.312,281.223 785.464,282.086 785.599,282.955Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M782.704,271.311L782.827,271.67C783.097,272.461 784.008,272.9 784.862,272.651C785.69,272.41 786.162,271.612 785.946,270.844L785.923,270.77C785.625,269.895 785.311,269.029 784.98,268.172L784.837,267.805C784.532,267.026 783.602,266.624 782.759,266.906C781.943,267.179 781.509,267.996 781.76,268.754L781.787,268.827C782.108,269.647 782.414,270.475 782.704,271.311Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.746,262.301L597.155,262.313C598.051,262.339 598.8,261.689 598.828,260.861C598.855,260.059 598.196,259.385 597.34,259.32L597.257,259.315C596.339,259.288 595.423,259.247 594.508,259.191L594.116,259.166C593.222,259.107 592.445,259.729 592.381,260.555C592.32,261.355 592.949,262.054 593.802,262.151L593.885,262.158C594.837,262.221 595.791,262.269 596.746,262.301Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.819,261.764L610.225,261.716C611.114,261.608 611.74,260.855 611.624,260.034C611.511,259.239 610.743,258.671 609.886,258.734L609.803,258.742C608.894,258.853 607.982,258.947 607.07,259.028L606.679,259.061C605.787,259.135 605.128,259.864 605.208,260.689C605.287,261.488 606.029,262.085 606.887,262.054L606.97,262.049C607.921,261.97 608.87,261.875 609.819,261.764Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M777.714,260.286L777.901,260.618C778.312,261.353 779.291,261.641 780.087,261.261C780.859,260.892 781.175,260.031 780.819,259.309L780.783,259.239C780.329,258.429 779.861,257.629 779.377,256.839L779.169,256.501C778.723,255.782 777.732,255.534 776.954,255.946C776.201,256.345 775.926,257.217 776.314,257.925L776.354,257.993C776.822,258.748 777.274,259.512 777.714,260.286Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.751,260.898L584.152,260.971C585.032,261.128 585.883,260.596 586.053,259.783C586.218,258.996 585.684,258.233 584.85,258.042L584.768,258.025C583.868,257.864 582.97,257.689 582.076,257.499L581.694,257.417C580.821,257.227 579.948,257.727 579.742,258.533C579.544,259.315 580.045,260.097 580.87,260.318L580.95,260.337C581.88,260.539 582.814,260.726 583.751,260.898Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.628,259.28L623.02,259.171C623.877,258.931 624.363,258.094 624.103,257.301C623.852,256.533 622.993,256.089 622.16,256.28L622.079,256.3C621.201,256.546 620.319,256.777 619.435,256.992L619.056,257.083C618.188,257.291 617.667,258.109 617.891,258.911C618.108,259.688 618.946,260.165 619.787,260.006L619.868,259.988C620.79,259.768 621.71,259.532 622.628,259.28Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.162,257.604L571.545,257.735C572.387,258.02 573.32,257.62 573.627,256.842C573.925,256.089 573.529,255.256 572.738,254.947L572.661,254.918C571.799,254.627 570.944,254.322 570.093,254.002L569.729,253.864C568.9,253.549 567.953,253.914 567.611,254.68C567.28,255.422 567.641,256.268 568.416,256.607L568.493,256.638C569.377,256.975 570.267,257.297 571.162,257.604Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-553.725,-183.866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.746,262.301L597.155,262.313C598.051,262.339 598.8,261.689 598.828,260.861C598.855,260.059 598.196,259.385 597.34,259.32L597.257,259.315C596.339,259.288 595.423,259.247 594.508,259.191L594.116,259.166C593.222,259.107 592.445,259.729 592.381,260.555C592.32,261.355 592.949,262.054 593.802,262.151L593.885,262.158C594.837,262.221 595.791,262.269 596.746,262.301Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-553.725,-183.866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.751,260.898L584.152,260.971C585.032,261.128 585.883,260.596 586.053,259.783C586.218,258.996 585.684,258.233 584.85,258.042L584.768,258.025C583.868,257.864 582.97,257.689 582.076,257.499L581.694,257.417C580.821,257.227 579.948,257.727 579.742,258.533C579.544,259.315 580.045,260.097 580.87,260.318L580.95,260.337C581.88,260.539 582.814,260.726 583.751,260.898Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-553.725,-183.866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.162,257.604L571.545,257.735C572.387,258.02 573.32,257.62 573.627,256.842C573.925,256.089 573.529,255.256 572.738,254.947L572.661,254.918C571.799,254.627 570.944,254.322 570.093,254.002L569.729,253.864C568.9,253.549 567.953,253.914 567.611,254.68C567.28,255.422 567.641,256.268 568.416,256.607L568.493,256.638C569.377,256.975 570.267,257.297 571.162,257.604Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.826,254.891L635.195,254.724C635.998,254.357 636.328,253.457 635.931,252.715C635.547,251.996 634.622,251.687 633.834,252.002L633.758,252.034C632.933,252.411 632.103,252.772 631.269,253.119L630.911,253.267C630.092,253.603 629.722,254.489 630.086,255.246C630.438,255.98 631.348,256.323 632.15,256.039L632.227,256.009C633.098,255.652 633.965,255.279 634.826,254.891Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.301,252.494L559.657,252.68C560.438,253.086 561.428,252.829 561.866,252.107C562.291,251.408 562.044,250.527 561.318,250.105L561.246,250.065C560.447,249.651 559.656,249.222 558.872,248.78L558.537,248.59C557.774,248.156 556.775,248.375 556.304,249.08C555.848,249.764 556.058,250.653 556.764,251.102L556.834,251.144C557.648,251.609 558.471,252.059 559.301,252.494Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M770.75,250.22L770.996,250.517C771.538,251.177 772.556,251.306 773.27,250.805C773.961,250.32 774.113,249.422 773.629,248.766L773.58,248.703C772.985,247.978 772.376,247.264 771.753,246.562L771.485,246.261C770.913,245.623 769.889,245.535 769.199,246.064C768.532,246.576 768.42,247.479 768.934,248.116L768.986,248.176C769.587,248.847 770.175,249.527 770.75,250.22Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646.082,248.719L646.417,248.498C647.146,248.015 647.313,247.078 646.791,246.405C646.285,245.752 645.318,245.587 644.596,246.016L644.527,246.059C643.778,246.555 643.023,247.037 642.262,247.505L641.935,247.704C641.187,248.159 640.978,249.089 641.47,249.781C641.947,250.452 642.906,250.654 643.647,250.252L643.718,250.211C644.512,249.728 645.301,249.231 646.082,248.719Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.485,245.681L548.803,245.917C549.503,246.435 550.524,246.33 551.085,245.683C551.627,245.057 551.538,244.151 550.896,243.625L550.832,243.575C550.118,243.047 549.413,242.506 548.718,241.953L548.42,241.715C547.744,241.171 546.719,241.237 546.13,241.862C545.561,242.468 545.61,243.375 546.229,243.926L546.29,243.978C547.012,244.559 547.744,245.126 548.485,245.681Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656.141,240.969L656.442,240.713C657.103,240.154 657.148,239.205 656.543,238.594C655.958,238.001 654.977,237.943 654.314,238.449L654.251,238.499C653.835,238.852 653.419,239.209 653.006,239.572C652.719,239.825 652.43,240.076 652.139,240.323L651.849,240.57C651.187,241.129 651.14,242.078 651.745,242.689C652.331,243.282 653.312,243.34 653.975,242.835L654.038,242.784C654.341,242.529 654.642,242.27 654.942,242.009L655.541,241.485C655.74,241.312 655.94,241.14 656.141,240.969Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M762.037,241.39L762.333,241.645C762.988,242.212 764.014,242.18 764.627,241.576C765.22,240.99 765.207,240.081 764.61,239.51L764.551,239.455C763.832,238.833 763.102,238.224 762.36,237.627L762.041,237.372C761.362,236.831 760.337,236.902 759.752,237.53C759.186,238.138 759.241,239.046 759.861,239.593L759.923,239.645C760.639,240.215 761.343,240.797 762.037,241.39Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.019,237.326L539.291,237.607C539.891,238.224 540.916,238.275 541.584,237.722C542.229,237.187 542.302,236.279 541.761,235.663L541.707,235.604C541.096,234.975 540.497,234.335 539.908,233.682L539.657,233.401C539.086,232.762 538.063,232.672 537.372,233.199C536.703,233.711 536.59,234.614 537.102,235.25L537.154,235.311C537.764,235.995 538.386,236.667 539.019,237.326Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-553.903,-182.988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.301,252.494L559.657,252.68C560.438,253.086 561.428,252.829 561.866,252.107C562.291,251.408 562.044,250.527 561.318,250.105L561.246,250.065C560.447,249.651 559.656,249.222 558.872,248.78L558.537,248.59C557.774,248.156 556.775,248.375 556.304,249.08C555.848,249.764 556.058,250.653 556.764,251.102L556.834,251.144C557.648,251.609 558.471,252.059 559.301,252.494Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M666.318,233.563L666.654,233.357C667.403,232.902 667.612,231.972 667.12,231.28C666.643,230.609 665.684,230.408 664.944,230.809L664.873,230.849C664.054,231.346 663.242,231.859 662.435,232.388L662.09,232.616C661.362,233.098 661.194,234.036 661.717,234.709C662.223,235.361 663.19,235.526 663.912,235.098L663.981,235.054C664.755,234.541 665.534,234.044 666.318,233.563Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M751.851,234.013L752.188,234.22C752.935,234.679 753.942,234.493 754.438,233.803C754.921,233.136 754.746,232.24 754.057,231.768L753.988,231.723C753.17,231.219 752.342,230.729 751.505,230.253L751.146,230.049C750.38,229.618 749.381,229.842 748.916,230.55C748.464,231.235 748.678,232.123 749.388,232.569L749.458,232.611C750.264,233.065 751.063,233.533 751.851,234.013Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.648,227.808L678.018,227.657C678.839,227.325 679.213,226.441 678.854,225.682C678.507,224.947 677.598,224.598 676.795,224.879L676.717,224.908C675.816,225.272 674.919,225.654 674.027,226.052L673.645,226.223C672.84,226.587 672.506,227.486 672.901,228.23C673.282,228.951 674.206,229.263 674.995,228.95L675.071,228.918C675.926,228.532 676.785,228.162 677.648,227.808Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.16,227.649L531.378,227.967C531.86,228.666 532.863,228.871 533.618,228.426C534.351,227.995 534.582,227.111 534.158,226.421L534.115,226.355C533.625,225.644 533.146,224.922 532.679,224.188L532.479,223.873C532.029,223.157 531.035,222.915 530.261,223.331C529.51,223.735 529.241,224.609 529.634,225.315L529.674,225.382C530.157,226.149 530.652,226.905 531.16,227.649Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M740.501,228.262L740.87,228.416C741.687,228.758 742.648,228.423 743.018,227.669C743.377,226.938 743.048,226.081 742.285,225.717L742.21,225.683C741.315,225.308 740.412,224.948 739.503,224.602L739.113,224.454C738.282,224.143 737.336,224.513 736.999,225.281C736.673,226.024 737.039,226.869 737.816,227.203L737.893,227.234C738.769,227.563 739.638,227.905 740.501,228.262Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.864,223.923L690.256,223.834C691.127,223.637 691.66,222.826 691.448,222.021C691.242,221.241 690.411,220.754 689.568,220.903L689.487,220.919C688.534,221.135 687.582,221.367 686.634,221.616L686.227,221.724C685.366,221.955 684.872,222.788 685.122,223.583C685.364,224.354 686.216,224.807 687.052,224.625L687.133,224.605C688.041,224.361 688.952,224.134 689.864,223.923Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728.297,224.274L728.688,224.371C729.552,224.587 730.444,224.114 730.677,223.314C730.904,222.539 730.431,221.743 729.614,221.496L729.534,221.474C728.585,221.238 727.631,221.016 726.673,220.81L726.263,220.723C725.389,220.54 724.52,221.046 724.321,221.854C724.129,222.637 724.637,223.415 725.463,223.63L725.544,223.649C726.466,223.843 727.383,224.051 728.297,224.274Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.627,222.034L703.029,222.007C703.924,221.951 704.599,221.236 704.538,220.409C704.48,219.609 703.751,218.998 702.893,219.011L702.81,219.014C701.83,219.076 700.85,219.155 699.871,219.25L699.451,219.292C698.561,219.383 697.918,220.125 698.018,220.948C698.113,221.746 698.869,222.328 699.726,222.281L699.809,222.274C700.748,222.178 701.688,222.098 702.627,222.034Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.559,222.167L715.962,222.203C716.853,222.286 717.65,221.685 717.738,220.861C717.825,220.062 717.218,219.347 716.368,219.228L716.285,219.218C715.308,219.128 714.327,219.053 713.344,218.996L712.922,218.972C712.028,218.923 711.261,219.555 711.208,220.382C711.157,221.183 711.796,221.874 712.65,221.961L712.733,221.967C713.678,222.018 714.62,222.085 715.559,222.167Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-545.49,-192.234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M740.501,228.262L740.87,228.416C741.687,228.758 742.648,228.423 743.018,227.669C743.377,226.938 743.048,226.081 742.285,225.717L742.21,225.683C741.315,225.308 740.412,224.948 739.503,224.602L739.113,224.454C738.282,224.143 737.336,224.513 736.999,225.281C736.673,226.024 737.039,226.869 737.816,227.203L737.893,227.234C738.769,227.563 739.638,227.905 740.501,228.262Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-545.49,-192.234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.864,223.923L690.256,223.834C691.127,223.637 691.66,222.826 691.448,222.021C691.242,221.241 690.411,220.754 689.568,220.903L689.487,220.919C688.534,221.135 687.582,221.367 686.634,221.616L686.227,221.724C685.366,221.955 684.872,222.788 685.122,223.583C685.364,224.354 686.216,224.807 687.052,224.625L687.133,224.605C688.041,224.361 688.952,224.134 689.864,223.923Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-545.49,-192.234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728.297,224.274L728.688,224.371C729.552,224.587 730.444,224.114 730.677,223.314C730.904,222.539 730.431,221.743 729.614,221.496L729.534,221.474C728.585,221.238 727.631,221.016 726.673,220.81L726.263,220.723C725.389,220.54 724.52,221.046 724.321,221.854C724.129,222.637 724.637,223.415 725.463,223.63L725.544,223.649C726.466,223.843 727.383,224.051 728.297,224.274Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-545.49,-192.234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.627,222.034L703.029,222.007C703.924,221.951 704.599,221.236 704.538,220.409C704.48,219.609 703.751,218.998 702.893,219.011L702.81,219.014C701.83,219.076 700.85,219.155 699.871,219.25L699.451,219.292C698.561,219.383 697.918,220.125 698.018,220.948C698.113,221.746 698.869,222.328 699.726,222.281L699.809,222.274C700.748,222.178 701.688,222.098 702.627,222.034Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-545.49,-192.234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.559,222.167L715.962,222.203C716.853,222.286 717.65,221.685 717.738,220.861C717.825,220.062 717.218,219.347 716.368,219.228L716.285,219.218C715.308,219.128 714.327,219.053 713.344,218.996L712.922,218.972C712.028,218.923 711.261,219.555 711.208,220.382C711.157,221.183 711.796,221.874 712.65,221.961L712.733,221.967C713.678,222.018 714.62,222.085 715.559,222.167Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.77,215.083L527.089,213.549C526.749,212.783 525.802,212.416 524.972,212.73C524.169,213.034 523.772,213.866 524.056,214.615L524.086,214.687L524.616,215.882C524.772,216.236 524.931,216.587 525.092,216.936L525.254,217.285C525.61,218.045 526.565,218.395 527.389,218.066C528.185,217.748 528.565,216.909 528.265,216.165L527.77,215.083Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.82,205.056L519.85,205.128L520.909,207.518C521.248,208.284 522.196,208.651 523.026,208.337C523.828,208.033 524.226,207.202 523.941,206.452L523.912,206.38L522.853,203.991C522.513,203.224 521.565,202.857 520.736,203.171C519.933,203.475 519.535,204.307 519.82,205.056Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.584,195.497L515.613,195.569L516.673,197.959C517.012,198.726 517.96,199.092 518.79,198.778C519.592,198.474 519.99,197.643 519.705,196.894L519.676,196.822L518.616,194.432C518.277,193.665 517.329,193.299 516.499,193.613C515.697,193.917 515.299,194.749 515.584,195.497Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.743,186.837L511.907,187.205L512.436,188.4C512.776,189.167 513.724,189.534 514.553,189.22C515.356,188.916 515.754,188.085 515.469,187.335L515.439,187.263L514.91,186.068C514.742,185.688 514.57,185.309 514.397,184.931L514.222,184.554C513.869,183.793 512.914,183.441 512.091,183.768C511.294,184.085 510.911,184.923 511.21,185.667L511.743,186.837Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.475,176.832L506.686,177.179C507.122,177.902 508.11,178.162 508.892,177.759C509.651,177.368 509.938,176.499 509.559,175.787L509.52,175.718C509.015,174.881 508.497,174.051 507.966,173.23L507.737,172.878C507.274,172.168 506.278,171.94 505.51,172.368C504.767,172.783 504.512,173.661 504.917,174.36L504.958,174.427C505.477,175.222 505.982,176.023 506.475,176.832Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.923,166.205L499.182,166.522C499.721,167.184 500.739,167.317 501.454,166.818C502.148,166.336 502.305,165.439 501.823,164.781L501.774,164.718C501.152,163.953 500.515,163.196 499.868,162.449L499.59,162.129C499.027,161.484 498.004,161.384 497.308,161.905C496.633,162.409 496.509,163.312 497.015,163.953L497.065,164.014C497.696,164.736 498.315,165.466 498.923,166.205Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.873,156.63L490.177,156.911C490.808,157.499 491.836,157.502 492.472,156.918C493.087,156.353 493.11,155.443 492.536,154.853L492.479,154.797C491.749,154.117 491.007,153.448 490.255,152.789L489.932,152.507C489.279,151.94 488.252,151.969 487.639,152.573C487.044,153.158 487.055,154.067 487.65,154.639L487.71,154.693C488.441,155.329 489.163,155.975 489.873,156.63Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.495,148.285L479.838,148.525C480.55,149.028 481.568,148.901 482.112,148.243C482.638,147.605 482.526,146.702 481.871,146.189L481.806,146.14C480.983,145.56 480.15,144.991 479.307,144.433L478.946,144.194C478.215,143.714 477.202,143.873 476.683,144.548C476.18,145.202 476.326,146.102 477,146.593L477.066,146.639C477.886,147.177 478.695,147.726 479.495,148.285Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-263.207,-100.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.983,141.327L468.357,141.522C469.137,141.93 470.127,141.676 470.569,140.955C470.996,140.257 470.752,139.376 470.027,138.951L469.956,138.911C469.569,138.71 469.181,138.509 468.792,138.312L467.054,137.437C466.266,137.042 465.281,137.311 464.853,138.039C464.439,138.744 464.699,139.62 465.432,140.035L465.504,140.073L466.852,140.75C467.231,140.941 467.607,141.133 467.983,141.327Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-544.769,-191.201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656.141,240.969L656.442,240.713C657.103,240.154 657.148,239.205 656.543,238.594C655.958,238.001 654.977,237.943 654.314,238.449L654.251,238.499C653.835,238.852 653.419,239.209 653.006,239.572C652.719,239.825 652.43,240.076 652.139,240.323L651.849,240.57C651.187,241.129 651.14,242.078 651.745,242.689C652.331,243.282 653.312,243.34 653.975,242.835L654.038,242.784C654.341,242.529 654.642,242.27 654.942,242.009L655.541,241.485C655.74,241.312 655.94,241.14 656.141,240.969Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-544.769,-191.201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M666.318,233.563L666.654,233.357C667.403,232.902 667.612,231.972 667.12,231.28C666.643,230.609 665.684,230.408 664.944,230.809L664.873,230.849C664.054,231.346 663.242,231.859 662.435,232.388L662.09,232.616C661.362,233.098 661.194,234.036 661.717,234.709C662.223,235.361 663.19,235.526 663.912,235.098L663.981,235.054C664.755,234.541 665.534,234.044 666.318,233.563Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-544.769,-191.201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.648,227.808L678.018,227.657C678.839,227.325 679.213,226.441 678.854,225.682C678.507,224.947 677.598,224.598 676.795,224.879L676.717,224.908C675.816,225.272 674.919,225.654 674.027,226.052L673.645,226.223C672.84,226.587 672.506,227.486 672.901,228.23C673.282,228.951 674.206,229.263 674.995,228.95L675.071,228.918C675.926,228.532 676.785,228.162 677.648,227.808Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-553.35,-183.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.819,261.764L610.225,261.716C611.114,261.608 611.74,260.855 611.624,260.034C611.511,259.239 610.743,258.671 609.886,258.734L609.803,258.742C608.894,258.853 607.982,258.947 607.07,259.028L606.679,259.061C605.787,259.135 605.128,259.864 605.208,260.689C605.287,261.488 606.029,262.085 606.887,262.054L606.97,262.049C607.921,261.97 608.87,261.875 609.819,261.764Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-553.35,-183.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.628,259.28L623.02,259.171C623.877,258.931 624.363,258.094 624.103,257.301C623.852,256.533 622.993,256.089 622.16,256.28L622.079,256.3C621.201,256.546 620.319,256.777 619.435,256.992L619.056,257.083C618.188,257.291 617.667,258.109 617.891,258.911C618.108,259.688 618.946,260.165 619.787,260.006L619.868,259.988C620.79,259.768 621.71,259.532 622.628,259.28Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-553.35,-183.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.826,254.891L635.195,254.724C635.998,254.357 636.328,253.457 635.931,252.715C635.547,251.996 634.622,251.687 633.834,252.002L633.758,252.034C632.933,252.411 632.103,252.772 631.269,253.119L630.911,253.267C630.092,253.603 629.722,254.489 630.086,255.246C630.438,255.98 631.348,256.323 632.15,256.039L632.227,256.009C633.098,255.652 633.965,255.279 634.826,254.891Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-553.35,-183.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646.082,248.719L646.417,248.498C647.146,248.015 647.313,247.078 646.791,246.405C646.285,245.752 645.318,245.587 644.596,246.016L644.527,246.059C643.778,246.555 643.023,247.037 642.262,247.505L641.935,247.704C641.187,248.159 640.978,249.089 641.47,249.781C641.947,250.452 642.906,250.654 643.647,250.252L643.718,250.211C644.512,249.728 645.301,249.231 646.082,248.719Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-553.35,-183.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656.141,240.969L656.442,240.713C657.103,240.154 657.148,239.205 656.543,238.594C655.958,238.001 654.977,237.943 654.314,238.449L654.251,238.499C653.835,238.852 653.419,239.209 653.006,239.572C652.719,239.825 652.43,240.076 652.139,240.323L651.849,240.57C651.187,241.129 651.14,242.078 651.745,242.689C652.331,243.282 653.312,243.34 653.975,242.835L654.038,242.784C654.341,242.529 654.642,242.27 654.942,242.009L655.541,241.485C655.74,241.312 655.94,241.14 656.141,240.969Z",
    style: {
      fill: "rgb(48 131 220)"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssistanceSlideLine3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/assistance-slide-line3.8a37a5ae6fb3332c033ee595e84fd549.svg";